__turbopack_context__.v({
  "buttonContainer": "LinkCard-module-scss-module__dh7meG__buttonContainer",
  "container": "LinkCard-module-scss-module__dh7meG__container",
  "mobileCenter": "LinkCard-module-scss-module__dh7meG__mobileCenter",
});
